var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-info 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1.125C6 1.125 1.125 6 1.125 12C1.125 18 6 22.875 12 22.875C18 22.875 22.875 18 22.875 12C22.875 6 18 1.125 12 1.125ZM12 2.25C17.3813 2.25 21.75 6.61875 21.75 12C21.75 17.3813 17.3813 21.75 12 21.75C6.61875 21.75 2.25 17.3813 2.25 12C2.25 6.61875 6.61875 2.25 12 2.25ZM12 5.625C11.5524 5.625 11.1232 5.80279 10.8068 6.11926C10.4903 6.43573 10.3125 6.86495 10.3125 7.3125C10.3125 7.76005 10.4903 8.18927 10.8068 8.50574C11.1232 8.82221 11.5524 9 12 9C12.4476 9 12.8768 8.82221 13.1932 8.50574C13.5097 8.18927 13.6875 7.76005 13.6875 7.3125C13.6875 6.86495 13.5097 6.43573 13.1932 6.11926C12.8768 5.80279 12.4476 5.625 12 5.625ZM12 11.0625C11.0625 11.0625 10.3125 11.8125 10.3125 12.75V17.25C10.3125 18.1875 11.0625 18.9375 12 18.9375C12.9375 18.9375 13.6875 18.1875 13.6875 17.25V12.75C13.6875 11.8125 12.9375 11.0625 12 11.0625Z",
    fill: "#735BF2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoPrimary);
export default __webpack_public_path__ + "static/media/iconInfoPrimary.9668735a9c0febf506db7c13c10ebb25.svg";
export { ForwardRef as ReactComponent };